// components/PasswordResetRequest.js
import classnames from "classnames";
// reactstrap components
// import Register from "views/pages/examples/Register";

import {
    UncontrolledAlert,
    Button,
    Card,
    CardBody,
    FormGroup,
    Form,
    Input,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
    Container,
    Row,
    Col,
} from "reactstrap";
// core components
import AuthHeader from "components/Headers/AuthHeader.js";

import { requestPasswordReset } from 'api/authApiCall';
import React, { useState } from 'react';
import { useTranslation } from '../i18n/context';

const PasswordResetRequest = () => {
    const { t } = useTranslation();
    const [focusedEmail, setfocusedEmail] = React.useState(false);
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await requestPasswordReset(email);
            setMessage(t('common.password_sent'));
        } catch (error) {
            setMessage(t('common.password_failed'));
        }
    };

    return (
        <>
            <AuthHeader
                title={t('common.welcome')}
                lead={t('common.request')}
            />
            <Container className="mt--8 pb-5">
                <Row className="justify-content-center">
                    <Col lg="5" md="7">
                        <Card className="bg-secondary border-0 mb-0">
                            <CardBody className="px-lg-5 py-lg-5">
                                <div className="text-center text-muted mb-4">
                                    <small>{t('common.enter_mail')}</small>
                                </div>
                                <Form role="form" onSubmit={handleSubmit}>
                                    <FormGroup
                                        className={classnames("mb-3", {
                                            focused: focusedEmail,
                                        })}
                                    >
                                        <InputGroup className="input-group-merge input-group-alternative">
                                            <InputGroupAddon addonType="prepend">
                                                <InputGroupText>
                                                    <i className="ni ni-email-83" />
                                                </InputGroupText>
                                            </InputGroupAddon>
                                            <Input
                                                type="email"
                                                value={email}
                                                onChange={(e) => setEmail(e.target.value)}
                                                required
                                                onFocus={() => setfocusedEmail(true)}
                                                onBlur={() => setfocusedEmail(true)}
                                            />
                                        </InputGroup>
                                    </FormGroup>

                                    <div className="text-center">
                                        <Button className="my-4" color="info" type="submit">
                                            {t('common.request_reset')}
                                        </Button>
                                    </div>
                                </Form>
                                {/* {message && <p>{message}</p>} */}
                                {message && (
                                    <UncontrolledAlert color="primary">
                                        <span className="alert-text ml-1">
                                            <strong>{message}</strong>
                                        </span>
                                    </UncontrolledAlert>
                                )}

                            </CardBody>
                        </Card>
                        <Row className="mt-3">
                            <Col xs="6">
                                <a
                                    className="text-light"
                                    href="/auth/login"

                                >
                                    <small
                                        style={{ fontWeight: 'bolder', color: 'black' }}
                                    >{t('common.loggin')}</small>
                                </a>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default PasswordResetRequest;


